import React from 'react';
import CustomModal from '../../baseComponents/gui/customModal/CustomModal';
import { useModal } from '../../../hooks/useModal';
import CustomButton from '../../features/customButton/ui/main/CustomButton';
import { safeHTML } from '../../../utils/safeHTML';
import { useTranslation } from '../../../translations';

const RatingInfoModal = React.forwardRef(function RatingInfoModal({ image, title, text, button }, ref) {
  const { closeModal, id } = useModal();
  const { t } = useTranslation();
  return (
    <CustomModal>
      <div className={'rating-info-modal'} ref={ref}>
        <div className={`rating-info-modal__image-box`}>
          <img src={image} alt={''} />
        </div>
        <div className={`rating-info-modal__content`}>
          <h2 className={`rating-info-modal__title`}>{safeHTML(t(title))}</h2>
          <p className={`rating-info-modal__text`}>{safeHTML(t(text))}</p>
          <CustomButton {...button} onClick={() => closeModal(id)} />
        </div>
      </div>
    </CustomModal>
  );
});

export default RatingInfoModal;
RatingInfoModal.propTypes = {};
